import * as React from "react";

function Menu(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM14 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 6a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-6 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM6.5 8a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM8 3.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM.5 14a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM2 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM.5 2a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z"
      />
    </svg>
  );
}

export default Menu;
